// const RightArrow = ({ color = "#8B909A", size = 20, className = "" }) => {
//   return (
//     <div>
//       <svg
//         width={size}
//         height={size}
//         viewBox="0 0 18 18"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//         className={`${className}`}
//       >
//         <g id="SVGRepo_bgCarrier" stroke-width="0" />

//         <g
//           id="SVGRepo_tracerCarrier"
//           stroke-linecap="round"
//           stroke-linejoin="round"
//         />

//         <g id="SVGRepo_iconCarrier">
//           <g>
//             <g>
//               <path d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005 L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251 l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z" />
//             </g>
//           </g>
//         </g>
//       </svg>
//     </div>
//   )
// }

// export default RightArrow;

const RightArrow = ({ color = "#8B909A", size = 16, className = "" }) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M5.5 15.5L13.5 9L5.5 2.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  export default RightArrow;